import Image from "next/image";
import Link from "next/link";
import { Button, Typography } from "@/components/ui";
import { env } from "@/lib/environment";

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  imageAlt: string;
  readMoreUrl: string;
}

interface BlogSectionProps {
  title?: string;
  viewAllUrl?: string;
  posts: BlogPost[];
}

export function BlogSection({
  title = "More Resources on Digital Signage Players",
  viewAllUrl = "/blog/",
  posts,
}: BlogSectionProps) {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <Typography variant="h2" as="h2" className="text-3xl font-bold text-text-primary">
              {title}
            </Typography>
          </div>
          <Link href={viewAllUrl}>
            <Button variant="outlinePrimary" className="btn-viewall text-primary" asChild>
              View All
              <Image
                src={env.NEXT_PUBLIC_CDN_URL + "/images/shared/arrow-right-black.FIDQmIA4mOGK.svg"}
                alt="Right arrow view all icon"
                title="Right arrow view all icon"
                width={19}
                height={15}
                className="inline ml-2"
                style={{ width: "19px", height: "15px" }}
              />
            </Button>
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {posts.map(post => (
            <article
              key={post.id}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
               <Link
                  href={post.readMoreUrl}
                  className="text-primary hover:text-red-800 font-medium text-sm"
                >
              <div className="relative overflow-hidden">
                <Image
                  src={post.imageUrl}
                  alt={post.imageAlt}
                  title={post.imageAlt}
                  width={344}
                  height={198}
                  className="w-full h-48 object-cover"
                />
              </div>
              <div className="p-6">
                <Typography
                  variant="h3"
                  as="h3"
                  className="mb-3 font-semibold text-lg text-text-primary"
                >
                  {post.title}
                </Typography>
                <Typography
                  variant="body"
                  as="p"
                  className="text-gray-600 mb-4 text-sm leading-relaxed"
                >
                  {post.excerpt}
                </Typography>
               
                  {/* <span>Read More</span> */}
              </div>
                </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
